const BAMBU_ERRORS = {
  50348032: 'Z축 원점 복귀 실패. 작업이 중지되었습니다.',
  50348033: '원점 복귀 전에 노즐이 식기를 기다리는 동안 프린터 대기시간이 초과되었습니다.',
  50348034: '자동 베드 레벨링 실패, 출력이 중지되었습니다.',
  50348037: '핫엔드 냉각 팬 속도가 비정상입니다.',
  50348038: '노즐이 막힌것 같습니다.',
  50348040: 'AMS가 필라멘트를 교체하지 못했습니다.',
  50348041: 'XY 축 원점 복귀에 실패했습니다.',
  50348042: '공진 주파수 식별에 실패했습니다.',
  50348043: '내부 통신 예외',
  50348044: '작업이 취소되었습니다.',
  50348045: '전원이 끊긴 후 다시 시작하지 못했습니다.',
  50348046: '모터 셀프 체크에 실패했습니다.',
  50348047: '전원 공급 장치 전압이 프린터와 일치하지 않습니다.',
  50348048: '노즐 오프셋 정 실패.',
  50348049: '동적 플럭스 보정 보정 실패; 출력 또는 보정을 다시 시작하십시오.',
  50348051: 'AMS가 건조되는 동안에는 출력을 시작할 수 없습니다.',
  50348052: 'Z축 원점 복귀 실패: 온도 제어 이상.',
  50348053: '노즐 덩어리 감지 보정 실패. 문제 해결을 위해 \'어시스턴트\'로 이동하십시오.',
  50348054: '노즐 세척 실패. 문제 해결을 위해 도우미를 클릭하세요.',
  50348063: '오른쪽 핫엔드가 설치되지 않아 툴헤드가 원점 복귀를 수행할 수 없습니다. 핫엔드를 설치한 후 계속 진행하세요.',
  50348064: '노즐 존재 감지 실패. 자세한 내용은 도우미를 참조하십시오.',
  50348065: '노즐 오프셋 보정 센서 신호 이상이 감지되었습니다. 센서를 확인하고 다시 시도하십시오.',
  50348098: '레이저 안전창이 제대로 설치되지 않았습니다. 작업이 중지되었습니다.',
  50348100: '화염 센서가 비정상입니다. 센서가 단락되었을 수 있습니다. 인쇄 작업을 시작하기 전에 문제를 해결하십시오.',
  50348107: '앞문이나 윗덮개가 열려 있어 작업이 중단되었습니다.',
  50348109: '핫엔드, 히트베드, 챔버의 현재 온도가 너무 높습니다. 작업을 다시 시작하기 전에 실온으로 냉각될 때까지 기다리십시오.',
  50348112: '라이브뷰 카메라 보정 시간 초과; 프린터를 다시 시작하십시오.',
  50348114: '칼날 Z축 원점 복귀 실패',
  50348134: '모션 정밀도 정 실패.',
  50348135: '보정 결과가 임계값을 초과했습니다.',
  50348136: '모션 정확도 향상 프로세스 중에 스텝 손실이 발생했습니다. 다시 시도하세요.',
  50364416: '알 수 없는 이유로 출력이 일시 중지되었습니다. “재개”를 선택하여 출력 작업을 재개할 수 있습니다.',
  50364417: '출력 파일에 추가된 일시 중지 명령어로 인해 출력이 일시 중지되었습니다.',
  50364418: '첫 번째 레이어 결함은 Micro Lidar에 의해 감지되었습니다. 출력을 계속하기 전에 출력 모델의 품질을 확인하십시오.',
  50364419: '스파게티 결함은 AI Print Monitoring에 의해 감지되었습니다. 출력을 계속하기 전에 출력된 모델의 품질을 확인하십시오.',
  50364420: '필라멘트가 소진되었습니다.새 필라멘트를 로드하십시오.',
  50364421: '툴헤드 전면 커버가 떨어졌습니다. 전면 커버를 다시 장착하고 출력이 제대로 되는지 확인하세요.',
  50364422: '빌드 플레이트 마커가 감지되지 않았습니다. 빌드 플레이트가 히트베드에 올바르게 위치했는지, 네 모서리가 모두 정렬되어 있고 마커가 보이는지 확인하십시오.',
  50364423: '프린터 전원이 꺼졌을 때 완료되지 않은 출력 작업이 있었습니다. 모델이 여전히 빌드 플레이트에 붙어 있으면 출력 작업을 재개해 볼 수 있습니다.',
  50364424: '노즐 온도 오류',
  50364425: '히트베드 온도 오류',
  50364426: 'AI 출력 모니터링에서 필라멘트 쌓임이 감지되었습니다. 폐기물 슈트에서 필라멘트를 청소하세요.',
  50364427: '커터가 끼었습니다. 커터 손잡이가 빠져 있는지 확인하고 필라멘트 센서 케이블 연결을 확인하십시오.',
  50364428: '단계 건너뛰기 감지됨: 자동 복구가 완료되었습니다. 출력을 다시 시작하고 레이어 이동 문제가 있는지 확인하십시오.',
  50364429: '압출기가 정상적으로 압출되지 않는 것을 감지했습니다. 결함이 허용 가능한 수준이면 \'재개\'를 선택하여 출력 작업을 다시 시작합니다.',
  50364430: '출력 파일을 찾을 수 없습니다. 저장 매체가 제거되었는지 확인하십시오.',
  50364431: '문이 열려 있는 것 같습니다. 인쇄가 일시 중지되었습니다.',
  50364432: '핫엔드 냉각 팬 속도가 비정상입니다.',
  50364433: '감지된 빌드 플레이트가 Gcode파일과 동일하지 않습니다. 슬라이서 설정을 조정하거나 올바른 플레이트를 사용하세요.',
  50364435: '인쇄 파일에 일시 중지 명령이 추가되어 인쇄가 일시 중지되었습니다.',
  50364436: '노즐이 필라멘트로 덮여 있거나 빌드 플레이트가 잘못 설치되었습니다. 이 출력을 취소하고 노즐을 청소하거나 상태에 따라 빌드 플레이트를 조정하세요. “재개”를 선택하여 출력 작업을 재개할 수도 있습니다.',
  50364437: '외부 스풀의 필라멘트가 떨어졌습니다. 새 필라멘트를 로드하십시오. 필라멘트가 로드되면 \'다시 시작\'을 선택하십시오.',
  50364438: '노즐이 필라멘트로 막혔습니다. 이 출력을 취소하고 노즐을 청소하거나 “재개”를 선택하여 출력 작업을 재개하십시오.',
  50364439: '히트베드에서 이물질이 감지되었습니다.히트베드를 점검하고 청소해 주세요.그런 다음 “재개”를 선택하여 출력 작업을 재개합니다.',
  50364440: '챔버 온도 오작동.',
  50364441: '빌드 플레이트가 장착되지 않았습니다.',
  50364442: '필라멘트 압출 오류; 문제 해결을 위해 도우미를 확인하세요. 문제를 해결한 후 실제 출력 상태에 따라 출력 작업을 취소할지 재개할지 결정하십시오.',
  50364443: '노즐 온도 문제가 감지되었습니다. 도우미를 참조하여 핫엔드 커넥터를 다시 연결하십시오. 이 작업을 수행하기 전에 합선을 방지하기 위해 프린터 전원을 끄십시오.',
  50364444: '압출 저항이 비정상입니다. 압출기가 막혔을 수 있으므로 도우미에게 문의하여 문제 해결 후 \'재개\' 버튼을 탭하여 출력 작업을 다시 시작할 수 있습니다.',
  50364445: '압출기 서보 모터 위치 센서가 오작동합니다. 먼저 프린터의 전원을 끄고 연결 케이블이 느슨하지 않은지 확인하십시오.',
  50364446: '압출 모터에 과부하가 걸린 경우 압출기가 막혔거나 필라멘트가 툴 헤드에 끼어 있는지 확인하세요.',
  50364449: '노즐이 설치되지 않았거나 제대로 설치되지 않았을 수 있습니다. 계속하기 전에 노즐이 올바르게 설치되었는지 확인하십시오.',
  50364450: '아래로 이동하는 동안 히트베드가 막힐 수 있습니다. 히트베드 아래에 있는 모든 물체를 치우고 이동 중에 저항이나 걸림이 없는지 확인하십시오.',
  50364456: '노즐 오프셋 보정 센서 오류. 단일 핫엔드를 사용하거나 보정 기능이 비활성화된 경우, 이 메시지를 무시하고 출력을 계속할 수 있습니다. 그렇지 않은 경우, 진행하기 전에 센서를 확인하는 것이 좋습니다.',
  50364481: '플랫폼 감지 시간 초과: 프린터를 다시 시작하십시오.',
  50364482: '도어 또는 상단 덮개가 열려 있어 작업이 일시 중지되었습니다.',
  50364483: '레이저 모듈이 비정상입니다.',
  50364484: '챔버 내부에서 화재가 감지되었습니다.',
  50364485: '재료 감지 시간 초과: 프린터를 다시 시작하세요.',
  50364486: '이물질 감지 시간 초과: 프린터를 다시 시작하세요.',
  50364487: '신속 이탈 레버 감지 시간 초과: 프린터를 다시 시작하세요.',
  50364488: '레이저 모듈 잠금 해제 시간이 초과되어 작업을 진행할 수 없습니다. 프린터를 다시 시작한 후 다시 시도하십시오.',
  50364489: '현재 플레이트가  유효하지 않습니다.',
  50364490: '비상 정지 버튼이 잘못 설치되었습니다. 계속하기 전에 위키에 따라 다시 설치하세요.',
  50364491: '작업이 일시 중지됨. 레이저 안전 창이 열려 있습니다.',
  50364494: '출력 작업입니다. 툴헤드에서 레이저/절단 모듈을 분리하십시오.',
  50364495: '현재 로드/언로드 프로세스가 진행 중입니다. 프로세스를 중지하거나 레이저/절단 모듈을 제거하십시오.',
  50364496: '이 기기는 40W 레이저 모듈을 지원하지 않습니다. 제거하거나 10W 레이저 모듈로 교체하십시오.',
  50364497: '커팅 모듈이 떨어졌거나 커팅 모듈 케이블이 분리되었습니다. 모듈을 확인하십시오.',
  50364499: '레이저 모듈이 감지되었습니다. 레이저 모듈 장착 보정을 정확히 수행하기 위해 정확한 노즐을 올바르게 설치하십시오.',
  50364500: '인쇄 후 자르기에 필요한 용지를 놓으세요.',
  50364501: '툴헤드에 장착된 모듈이 작업과 일치하지 않습니다. 올바른 모듈을 설치하십시오.',
  50364513: '기류 시스템 모드 활성화 실패. 에어 도어 상태를 확인하세요.',
  50364514: '챔버 온도가 너무 높습니다. 환경 온도가 높기 때문일 수 있습니다.',
  50364515: '챔버 온도가 너무 높습니다. 상단 덮개와 전면 도어를 열어 열을 식혀주세요.',
  50364516: '챔버 온도가 너무 높습니다. 상단 덮개와 전면 도어를 열어 열을 식히십시오. (이 인쇄 작업의 문 열림 감지는 \'알림\' 수준으로 설정됩니다.)',
  50364517: 'MC 모듈의 온도가 너무 높습니다. 가능한 설명은 Wiki를 확인하십시오.',
  50364529: '툴헤드 강화형 냉각 팬 모듈이 고장났습니다.',
  50364541: '소화기가 감지되지 않았습니다. 자동 화재 진압 기능을 사용할 수 없습니다.',
  50364542: '소화기가 감지되지 않았습니다. 자동 화재 진압 기능을 사용할 수 없습니다.',
  50364543: '소화기가 고장났습니다.',
  50364544: '소화기 모터 리셋 실패.',
  50364545: '소화기 실린더가 설치되지 않았습니다. 소화기 페이지에서 확인해 주세요.',
  50364546: '소화기 가스 실린더가 비어 있습니다.',
  50380818: '노즐을 170°C 이상으로 가열하십시오.',
  50380886: '챔버 내부에서 소규모 화재가 감지되어 자동 화재 진압 시스템이 중단되었습니다.',
  50380912: '레이저 모듈이 연결되면 소화기가 감지되어 사용할 수 있습니다.',
  83902465: 'Bambu Cloud에 연결하지 못했습니다. 네트워크 연결을 확인하십시오.',
  83902466: '지원되지 않는 출력 파일 경로 또는 이름입니다. 출력 작업을 다시 보내주십시오.',
  83902467: 'gcode.3mf를 분석하는 중에 문제가 발생했습니다. 출력 작업을 다시 보내십시오.',
  83902468: '장치가 사용 중이어서 새 작업을 시작할 수 없습니다. 새 작업을 보내기 전에 현재 작업이 완료될 때까지 기다려 주세요.',
  83902469: '펌웨어를 업데이트하는 동안에는 인쇄 작업을 전송할 수 없습니다.',
  83902470: '출력 작업을 위한 사용 가능한 저장 공간이 충분하지 않습니다. 공장 설정으로 복원하면 사용 가능한 공간을 확보할 수 있습니다.',
  83902471: '이 장치는 수리 업그레이드가 필요하며 현재 출력을 사용할 수 없습니다.',
  83902472: '출력 시작 실패. 프린터 전원을 껐다가 다시 켜고 출력 작업을 다시 보내십시오.',
  83902473: '로그를 업데이트하는 동안에는 인쇄 작업을 전송할 수 없습니다.',
  83902474: '지원되지 않는 파일명 입니다. 파일명을 변경 후 출력 작업을 다시 시작하십시오.',
  83902475: '파일을 다운로드하는 중 문제가 발생했습니다. 네트워크 연결을 확인하고 출력 작업을 다시 전송하십시오.',
  83902476: 'MicroSD 카드를 삽입하고 출력 작업을 다시 시작하십시오.',
  83902477: '셀프 테스트를 실행하고 출력 작업을 다시 시작하십시오.',
  83902478: '출력이 취소되었습니다.',
  83902479: 'AMS가 초기화 중이며 현재 업그레이드가 불가능합니다. 나중에 다시 시도해 주시기 바랍니다.',
  83902480: 'AMS가 현재 건조 중이며, 현재는 업그레이드가 불가능합니다. 나중에 다시 시도해 주시기 바랍니다.',
  83902481: '프린터가 필라멘트를 로딩 중이거나 언로딩 중이며 현재 업그레이드가 불가능합니다. 나중에 다시 시도해 주시기 바랍니다.',
  83902482: '장치가 출력 중이며 현재 업그레이드가 불가능합니다. 나중에 다시 시도해 주시기 바랍니다.',
  83902483: 'AMS는 현재 작동 중이며 현재 업그레이드가 불가능합니다. 유휴 상태일 때 다시 시도해 주세요.',
  83902484: '클라우드 슬라이싱에서 오류가 발생하였습니다. 매개변수를 확인하고 인쇄를 다시 시작하십시오.',
  83902485: '출력 작업을 위한 사용 가능한 저장 공간이 충분하지 않습니다. MicroSD 카드에서 파일을 포맷하거나 지워 공간을 확보하세요.',
  83902486: 'microSD 카드는 쓰기 방지되어 있습니다. microSD 카드를 교체하십시오',
  83902487: '바인딩에 실패했습니다. 다시 시도하거나 프린터를 다시 시작한 후 다시 시도하세요.',
  83902488: '바인딩 구성 정보 분석에 실패했습니다. 다시 시도하세요.',
  83902489: '프린터가 이미 바인딩되었습니다. 바인딩을 해제하고 다시 시도하십시오.',
  83902490: '클라우드 연결에 실패했습니다. 가능한 원인으로는 네트워크 불안정, 인터넷에 액세스할 수 없거나 라우터 방화벽 구성 제한 등이 있습니다. 프린터를 라우터에 더 가깝게 이동하거나 라우터 구성을 확인한 다음 다시 시도해 보세요.',
  83902491: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902492: '클라우드 연결이 거부되었습니다. 여러 번 시도했는데도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902493: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83902494: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902495: '인증 시간이 초과되었습니다. 휴대폰이나 PC가 인터넷에 연결되어 있는지 확인하고 바인딩 작업 중에 Bambu Studio/Bambu Handy 앱이 실행되고 있는지 확인하세요.',
  83902496: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83902497: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83902498: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902499: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83902500: '클라우드 연결에 실패했습니다. 가능한 원인으로는 네트워크 불안정, 인터넷에 액세스할 수 없거나 라우터 방화벽 구성 제한 등이 있습니다. 프린터를 라우터에 더 가깝게 이동하거나 라우터 구성을 확인한 다음 다시 시도해 보세요.',
  83902501: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902502: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83902503: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83902504: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902505: '클라우드 연결이 거부되었습니다. 여러 번 시도했는데도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83902506: '라우터에 연결하지 못했습니다. 무선 연결이 불안정 합니다. 라우터와 너무 멀리 떨어져 있기 때문일 수 있습니다. 다시 시도하거나 프린터를 라우터 근처로 이동한 다음 다시 시도하십시오.',
  83902507: '잘못된 비밀번호로 인해 라우터 연결에 실패했습니다. 비밀번호를 확인하고 다시 시도하세요.',
  83902508: 'IP 주소를 얻지 못했습니다. 무선 간섭으로 인해 데이터 전송이 실패했거나 라우터의 DHCP 주소 풀이 꽉 찼기 때문일 수 있습니다.프린터를 라우터에 더 가까이 놓고 다시 시도하십시오.문제가 계속되면 라우터 설정을 확인하여 IP 주소가 모두 사용되었는지 확인하십시오.',
  83902509: '시스템 예외',
  83902510: '시스템이 현재 MicroSD 카드에서 사용하는 파일 시스템을 지원하지 않습니다. MicroSD 카드를 교체하거나 MicroSD 카드를 FAT32로 포맷하십시오.',
  83902511: 'MicroSD 카드 섹터 데이터가 손상되었습니다. SD 카드 복구 도구를 사용하여 복구하거나 포맷하십시오. 그래도 식별할 수 없으면 MicroSD 카드를 교체하십시오.',
  83902512: '장치가 현재 업그레이드 중입니다. 사용이 가능해지면 다시 시도해 주시기 바랍니다.',
  83902513: '보조품 펌웨어가 프린터와 일치하지 않습니다. “펌웨어” 페이지에서 업그레이드하십시오.',
  83902515: 'AMS 펌웨어가 프린터와 일치하지 않습니다. \'펌웨어\' 페이지에서 업그레이드하십시오.',
  83902516: '레이저 모듈 펌웨어가 프린터와 일치하지 않습니다. \'펌웨어\' 페이지에서 업그레이드하십시오.',
  83902517: '전망 카메라가 제대로 작동하지 않습니다. 기기를 다시 시작해 보십시오. 여러 번 다시 시작한 후에도 문제가 지속되면 카메라 연결 상태를 확인하거나 고객 지원팀에 문의하세요.',
  83902519: '슬라이스된 파일이 현재 프린터 모델과 호환되지 않습니다. 이 파일은 이 프린터에서 출력할 수 없습니다.',
  83902520: '슬라이스된 파일의 노즐 지름이 현재 노즐 설정과 일치하지 않습니다.이 파일은 출력할 수 없습니다.',
  83902521: '현재 작업에서는 레이저/절단 모듈 설치를 허용하지 않아 작업이 중단되었습니다.',
  83902522: '현재 온도가 너무 낮습니다. 사용자와 프린터를 보호하기 위해서입니다. 출력 작업, 축 이동 및 기타 작업이 비활성화됩니다. 프린터를 섭씨 10도 이상의 환경으로 옮기십시오.',
  83902523: '지금은 기계에서 레이저/절단 작업을 시작할 수 없습니다. 작업을 시작하려면 컴퓨터 소프트웨어를 사용하십시오.',
  83902524: '현재 노즐 설정이 슬라이싱 파일과 일치하지 않습니다. 인쇄를 계속하면 인쇄 품질에 영향을 줄 수 있습니다. 인쇄를 시작하기 전에 슬라이싱을 다시 수행하는 것이 좋습니다.',
  83902525: '툴헤드 모듈이 설정되지 않았습니다. 작업을 시작하기 전에 설정하십시오.',
  83902526: '현재 도구 헤드는 초기화를 지원하지 않습니다.',
  83902527: '출력 작업을 다운로드하지 못했습니다. 네트워크 연결을 확인하십시오.',
  83902528: '프린터의 전원 제한에 도달했습니다. 건조를 사용하려면 전용 전원 어댑터를 이 AMS에 연결하세요.',
  83902529: '출력 중에는 AMS 건조를 시작할 수 없습니다.',
  83902530: '전력 제한으로 인해 AMS 건조를 시작하면 노즐 가열 및 팬 작동 등 현재 진행 중인 작업이 일시 중지됩니다. 건조를 계속하시겠습니까?',
  83902531: '전력 제한으로 인해 장치 전원으로 AMS 한 대만 건조에 사용할 수 있습니다.',
  83902532: '전망 카메라 오작동: 고객 서비스에 문의하세요.',
  83902533: '핫엔드 점검 중입니다. 이 작업은 일시적으로 사용할 수 없습니다. 잠시 기다려 주시기 바랍니다.',
  83902544: '출력 보드에서 오류가 감지되었습니다.',
  83902546: '핫엔드에서 오류가 감지되었습니다.',
  83902548: '매트에서 오류가 감지되었습니다.',
  83902557: '레이저 모듈 일련 번호 오류: 보정하거나 프로젝트를 만들 수 없습니다.',
  83902565: '작업에는 레이저 플랫폼이 필요하지만 현재 플랫폼은 절단 플랫폼입니다. 교체하고 소프트웨어에서 재료 두께를 측정한 다음 작업을 다시 시작하십시오.',
  83902576: '레이저 또는 커터 모듈이 연결되어 있어 장치가 3D 프린팅 작업을 시작할 수 없습니다.',
  83902581: '레이저 플랫폼이 감지되지 않아 두께 측정 정확도에 영향을 미칠 수 있습니다. 레이저 플랫폼을 올바르게 배치하고 후면 마커가 안 가려졌는지 확인한 다음 작업을 시작하기 전에 소프트웨어에서 두께 측정을 다시 시작하십시오.',
  83902582: '레이저 플랫폼을 올바르게 배치하고 후면 마커가 막히지 않았는지 확인한 다음 작업을 시작하기 전에 소프트웨어에서 두께 측정을 다시 시작하십시오.',
  83902615: '장치가 레이저 모듈을 감지하지 못했습니다. 모듈 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83902616: '장치가 AMS A를 감지하지 못했습니다. AMS 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83902617: '커팅 모듈의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  83902618: '공기 펌프의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  83902619: '레이저 모듈의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  83902621: 'AMS A의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업그레이드하십시오.',
  83902622: '장치가 커팅 모듈을 감지하지 못했습니다. 모듈 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83902623: '장치가 공기 펌프를 감지하지 못했습니다. 모듈 케이블을 다시 연결하거나 프린터를 재시작해 주세요.',
  83902624: '장치가 레이저 4축을 감지하지 못했습니다. 모듈 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83902625: '장치가 소화기를 감지하지 못했습니다. 모듈 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83902627: 'AMS(또는 AMS lite) A 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  83902628: '현재 펌웨어는 AMS Lite 1개만 지원합니다. 지원되는 AMS Lite 장치를 다시 연결하기 전에 모든 AMS 장치를 제거하십시오.',
  83902629: '현재 펌웨어는 AMS/AMS 2 Pro/AMS HT만 지원하며, 최대 4대까지 연결 가능합니다. 지원되는 장치를 다시 연결하기 전에 모든 AMS 장치를 제거하십시오.',
  83918867: '출력 파일을 찾을 수 없습니다. 저장 매체가 제거되었는지 확인하십시오.',
  83918896: '',
  83918902: '슬라이스된 파일이 현재 프린터 모델과 일치하지 않습니다.계속하시겠습니까?',
  83918908: '현재 노즐 설정이 슬라이싱 파일과 일치하지 않습니다. 인쇄를 계속하면 인쇄 품질에 영향을 줄 수 있습니다. 인쇄를 시작하기 전에 슬라이싱을 다시 수행하는 것이 좋습니다.',
  83918912: '툴헤드 앞 커버가 분리되었습니다. 툴헤드를 이동하면 프린터가 손상될 수 있습니다. 계속하시겠습니까?',
  83918913: '핫엔드의 필라멘트가 너무 차갑습니다. 압출 시 압출기가 손상될 수 있습니다. 필라멘트를 계속 공급/배출하고 있습니까?',
  83918929: '감지된 빌드 플레이트가 Gcode파일과 동일하지 않습니다. 슬라이서 설정을 조정하거나 올바른 플레이트를 사용하세요.',
  83918931: '왼쪽 및 오른쪽 노즐이 슬라이싱 파일과 일치하지 않습니다. 다시 슬라이싱한 후 출력을 시작하거나 올바른 노즐을 교체한 후 출력을 계속하십시오. 주의: 핫엔드 온도가 높습니다.',
  83918933: '레이저 모듈이 설치되었지만 절단 플랫폼이 감지되었습니다. 레이저 플랫폼을 배치하고 레이저 보정을 수행하십시오.',
  83918934: '커팅 모듈이 설치되었지만 레이저 플랫폼이 감지되었습니다. 보정을 위해 커팅 플랫폼을 배치하세요.',
  83918936: '라이트 그립 커팅 매트를 올바르게 배치하고 마커가 노출되도록 하세요.',
  83918937: '커팅 플랫폼 베이스가 제대로 정렬되지 않았습니다. 플랫폼의 네 모서리가 히트베드와 정렬되어 있는지 확인하십시오.',
  83918938: '커팅 매트를 커팅 보호 베이스에 올려 놓으십시오.',
  83918939: '커팅 매트 유형을 알 수 없습니다. 올바른 커팅 매트로 교체하십시오.',
  83918940: '그립 커팅 매트 유형이 일치하지 않습니다. LightGrip 커팅 매트를 깔아주세요.',
  83918942: '커팅 모듈 일련 번호 오류: 보정하거나 프로젝트를 만들 수 없습니다.',
  83918944: '툴헤드의 현재 모듈이 요구 사항을 충족하지 않습니다. 화면의 지시에 따라 모듈을 교체하십시오.',
  83918945: '출력 플레이트가 감지되지 않았습니다. 올바르게 배치되었는지 확인하십시오.',
  83918946: '출력 플레이트 마커가 감지되지 않았습니다. 출력 플레이트가 히트베드에 제대로 위치했는지, 네 모서리가 모두 정렬되었는지, 그리고 마커가 보이는지 확인하십시오. 인쇄 용지에 강한 빛이 비치는 경우, 전면 도어를 닫고 외부 광원을 차단하는 것이 좋습니다.',
  83918947: '보정 중에 플랫폼이 감지되지 않습니다. 레이저 플랫폼이 제대로 배치되었는지 확인하십시오.',
  83918948: '레이저 플랫폼을 올바른 위치에 놓고 레이저 교정을 위해 후면 마커가 가려지지 않았는지 확인하세요.',
  83918950: '이 작업에는 커팅 플랫폼이 필요하지만, 현재 커팅 플랫폼은 레이저 플랫폼입니다. 커팅 플랫폼(커팅 보호 베이스 + LightGrip 커팅 매트)으로 교체해 주세요.',
  83918951: '절단 보호대 위에 라이트그립 커팅 매트를 깔아주세요.',
  83918952: '스트롱 그립 커팅 매트를 올바르게 놓고 마커가 노출되었는지 확인하십시오.',
  83918953: '왼쪽 및 오른쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 핫엔드 유형을 수동으로 설정하세요.',
  83918954: '왼쪽 및 오른쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 다음 출력 전에 프린터 화면에서 핫엔드 유형을 설정하십시오.',
  83918955: '신속 이탈 레버가 잠기지 않았습니다. 외부 툴헤드 모듈을 눌러 제대로 장착되었는지 확인한 다음 레벨을 아래로 눌러 제자리에 고정하세요.',
  83918956: '커팅 플랫폼을 올바르게 배치하고 마커가 노출되었는지 확인하십시오.',
  83918957: '재료가 감지되지 않았습니다. 배치를 확인한 후 계속하세요.',
  83918958: '히트베드에서 이물질이 검출되었습니다. 히트베드를 확인하고 청소하십시오.',
  83918959: '그립 커팅 매트 유형이 일치하지 않습니다. StrongGrip 커팅 매트를 깔아주세요.',
  83918961: '절단 플랫폼이 감지되지 않았습니다. 올바르게 배치되었는지 확인하세요.',
  83918962: '라이브뷰 카메라가 차단됨',
  83918963: '히트베드 리미트 블록이 막혔거나 오염되었습니다. 리미트 블록이 보이지 않으면 플랫폼 위치 오프셋 감지가 부정확할 수 있으므로 청소하고 리미트 블록이 잘 보이도록 하세요.',
  83918964: '레이저 플랫폼은 오프셋되어 있습니다. 플랫폼의 네 모서리가 히트베드와 정렬되어 있고 마커가 안 가려졌는지 확인하십시오.',
  83918967: '시각적 마커가 감지되지 않았습니다. 용지가 올바르게 배치되었는지 확인하세요.',
  83918968: '현재 자료가 슬라이스된 파일 설정과 일치하지 않습니다. 올바른 자료를 로드하고 자료의 QR 코드가 손상되거나 더러워지지 않았는지 확인하세요.',
  83918969: '레이저 테스트 재료(350g 판지)를 놓고 그 아래에 지지대를 배치하여 재료가 뒤틀리는 것을 방지하세요.',
  83918970: '이물질 감지 기능이 작동하지 않습니다. 작업을 계속 진행하거나 문제 해결을 위한 도우미를 볼 수 있습니다.',
  83918971: '커팅 플랫폼(커팅 보호 베이스 + 라이트그립 커팅 매트)을 놓으세요.',
  83918972: '커팅 플랫폼(커팅 보호 베이스 + 스트롱그립 커팅 매트)을 놓으세요.',
  83918973: '이 작업에는 커팅 플랫폼이 필요하지만 현재는 레이저 플랫폼입니다. 커팅 플랫폼(커팅 보호 베이스 + StrongGrip 커팅 매트)으로 교체해 주세요.',
  83918974: '스트롱그립 커팅 매트를 커팅 보호 베이스 위에 올려주세요.',
  83918976: '왼쪽과 오른쪽 핫엔드가 설치되지 않았습니다.',
  83918977: '왼쪽과 오른쪽 핫엔드가 설치되지 않았습니다.',
  83918978: '가공하기 전에 불투명 광택 아크릴의 보호 필름을 제거하세요',
  83918979: '장착 보정에는 재료가 허용되지 않습니다. 플랫폼에서 재료를 제거하세요.',
  83918980: '라이브 뷰 카메라가 더럽습니다. 청소하고 계속하세요.',
  83918981: '툴헤드 카메라가 가려져 있습니다',
  83918982: '툴헤드 카메라가 더러워 AI 기능에 영향을 미칩니다. 렌즈 표면을 청소하십시오.',
  83918983: '전망 카메라가 가려졌습니다.',
  83918984: '전망 카메라가 더럽습니다.',
  83918985: '존재 확인 실패로 인해 작업이 일시 중지되었습니다. 계속하려면 프린터를 확인하십시오.',
  83918986: '전망 카메라는 오프셋으로 설치됩니다. 다시 설치하려면 도우미에게 문의하세요.',
  83918987: '전망 카메라 설치에 실패했습니다. 히트베드의 모든 물체와 매트를 제거하여 히트베드 마커가 잘 보이도록 하세요. 그동안 전망 카메라가 올바르게 설치되었는지 확인하고 카메라 시야를 가리는 장애물을 모두 제거하세요.',
  83918988: '빌드 플레이트 오프셋이 감지되었습니다. 빌드 플레이트를 히트베드에 맞춘 후 계속 진행하세요.',
  83918989: '절단 모듈 오프셋 보정에 실패하여 절단 결과가 부정확할 수 있습니다. 절단 재료가 제대로 위치했는지 확인하고 절단 날 끝이 마모되었는지 확인하세요.',
  83918990: '전망 카메라 초기화에 실패했습니다. 툴헤드 카메라가 히트베드 기능을 감지하지 못했습니다. 히트베드를 청소하고 모든 물체와 패드를 제거하고 침대 표시가 보이는지 확인하십시오. 자세한 해결책은 도우미를 확인하십시오.',
  83918991: '노즐 카메라 렌즈가 더러워져 AI 모니터링에 영향을 미칩니다. 부직포 천과 소량의 알코올로 렌즈를 닦으세요. 핫엔드 열에 주의하세요. 온도가 식을 때까지 기다렸다가 다루십시오.',
  83918992: '80g 흰색 인쇄용지를 플랫폼의 중앙 부분에 부착하세요.',
  83918993: '절단 모듈 오프셋 보정에 실패하여 절단 결과가 부정확할 수 있습니다. 80g 흰색 프린터 용지(레터 용지 두께)가 제대로 장착되어 있는지 확인하고 절단 날 끝이 마모되었는지 확인하십시오.',
  83918994: '툴헤드 카메라 초기화 실패. 이 출력은 계속 진행될 수 있지만 일부 AI 기능이 사용 불가합니다. 재시작 후에도 이 문제가 다시 발생하면 고객 지원 센터로 연락해 주시기 바랍니다.',
  83918995: '노즐 실리콘 슬리브가 설치되어 있지 않습니다. 온도 조절이 제대로 작동하지 않을 수 있습니다. 올바르게 설치한 후 다시 시도하십시오.',
  83919008: '비주얼 인코더 보드가 감지되지 않았습니다. 보드가 네 모서리 모두에 올바르게 배치되고 정렬되었는지 확인하고 위치 표시가 명확하고 마모되지 않았는지 확인하십시오.',
  83935248: 'MicroSD 카드 읽기/쓰기 예외: MicroSD 카드를 다시 삽입하거나 교체하십시오.',
  83935249: '',
  83935282: '툴헤드에 연결된 레이저/커팅 모듈. 건조 프로세스가 자동으로 중지되었습니다.',
  83935286: '출력 작업입니다. 툴헤드에서 레이저/절단 모듈을 분리하십시오.',
  83935359: '장치가 사용 중이어서 이 작업을 수행할 수 없습니다. 계속하려면 현재 작업을 일시 중지하거나 중단하세요.',
  83968023: '바인딩에 실패했습니다. 다시 시도하거나 프린터를 다시 시작한 후 다시 시도하세요.',
  83968024: '바인딩 구성 정보 분석에 실패했습니다. 다시 시도하세요.',
  83968025: '프린터가 이미 바인딩되었습니다. 바인딩을 해제하고 다시 시도하십시오.',
  83968026: '클라우드 연결에 실패했습니다. 가능한 원인으로는 네트워크 불안정, 인터넷에 액세스할 수 없거나 라우터 방화벽 구성 제한 등이 있습니다. 프린터를 라우터에 더 가깝게 이동하거나 라우터 구성을 확인한 다음 다시 시도해 보세요.',
  83968027: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968028: '클라우드 연결이 거부되었습니다. 여러 번 시도했는데도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968029: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83968030: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968031: '인증 시간이 초과되었습니다. 휴대폰이나 PC가 인터넷에 연결되어 있는지 확인하고 바인딩 작업 중에 Bambu Studio/Bambu Handy 앱이 실행되고 있는지 확인하세요.',
  83968032: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83968033: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83968034: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968035: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83968036: '클라우드 연결에 실패했습니다. 가능한 원인으로는 네트워크 불안정, 인터넷에 액세스할 수 없거나 라우터 방화벽 구성 제한 등이 있습니다. 프린터를 라우터에 더 가깝게 이동하거나 라우터 구성을 확인한 다음 다시 시도해 보세요.',
  83968037: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968038: '클라우드 연결이 거부되었습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하십시오.',
  83968039: '클라우드 연결에 실패했습니다. 이는 네트워크 불안정으로 인한 것일 수 있습니다. 다시 시도하기 전에 프린터를 라우터에 더 가까이 이동해 보세요.',
  83968040: '클라우드 응답이 유효하지 않습니다. 여러 번 시도해도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968041: '클라우드 연결이 거부되었습니다. 여러 번 시도했는데도 계속 실패하는 경우 고객 서비스에 문의하세요.',
  83968049: '장치 검색 바인딩이 진행 중이며, QR 코드를 화면에 표시할 수 없습니다. 바인딩이 완료될 때까지 기다리거나 APP/Studio에서 장치 검색 바인딩 프로세스를 중단하고 화면에서 QR 코드를 스캔하여 바인딩을 다시 시도할 수 있습니다.',
  83968050: 'QR 코드 바인딩이 진행 중이므로 장치 검색 바인딩을 수행할 수 없습니다.화면의 QR 코드를 스캔하여 바인딩하거나 화면의 QR 코드 표시 페이지를 종료하고 장치 검색 바인딩을 시도할 수 있습니다.',
  83968051: '사용 중인 앱 지역이 프린터와 일치하지 않습니다. 해당 지역에서 앱을 다운로드하고 계정을 다시 등록하십시오.',
  83968052: '슬라이싱 진행률이 오랫동안 업데이트되지 않아 인쇄 작업이 종료되었습니다.매개변수를 확인하고 인쇄를 다시 시작하십시오.',
  83968053: '장치가 바인딩 중이므로 새로운 바인딩 요청에 응답할 수 없습니다.',
  83968056: '지역 설정이 프린터와 일치하지 않습니다. 프린터의 지역 설정을 확인하십시오.',
  83968057: '기기 로그인이 만료되었습니다. 다시 바인딩해 보십시오.',
  83968152: '장치가 AMS B를 감지하지 못했습니다. AMS 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  83968157: 'AMS B의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  83968163: 'AMS(또는 AMS lite) B 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  84033537: '이 출력 작업에는 현재 필라멘트가 사용됩니다.설정을 변경할 수 없습니다.',
  84033538: '모션 정확도 향상 모드를 활성화하기 전에 \'설정 > 보정\'으로 이동하여 모션 정확도 향상 보정을 실행해 주세요.',
  84033539: '프린터가 현재 인쇄 중이며 모션 정확도 향상 기능을 켜거나 끌 수 없습니다.',
  84033540: '일부 기능은 현재 디바이스에서 지원되지 않습니다. Studio 기능 설정을 확인하거나 펌웨어를 최신 버전으로 업데이트하세요.',
  84033541: 'AMS가 아직 보정되지 않았으므로 출력을 시작할 수 없습니다.',
  84033542: '알 수 없는 모듈이 감지되었습니다. 펌웨어를 최신 버전으로 업데이트해 보세요.',
  84033549: '새 작업 시작 실패: 필라멘트 로드/언로드가 완료되지 않았습니다.',
  84033550: '새 작업 시작 실패: 노즐 저온 당김이 완료되지 않았습니다.',
  84033555: '이 장치는 40W 레이저 모듈과 호환되지 않습니다. 10W 레이저 모듈로 교체하거나 제거해 주세요.',
  84033688: '장치가 AMS C를 감지하지 못했습니다. AMS 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  84033693: 'AMS C의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업그레이드하십시오.',
  84033699: 'AMS(또는 AMS lite) C 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  84066319: '장치가 사용 중이어서 노즐 식별을 수행할 수 없습니다.',
  84066320: '프린터 전원 제한으로 인해 AMS 건조 중에는 출력, 보정, 제어 및 기타 작업을 수행할 수 없습니다. 다른 작업을 진행하기 전에 건조 프로세스를 중지하십시오.',
  84066321: '현재 2D 제작 모드입니다. 프린터에서 작업을 계속 진행해 주세요.',
  84066322: '작업을 일시 중지할 수 없습니다.',
  84066324: 'AMS 잔여 필라멘트 추정 기능은 기본적으로 활성화되어 있으며 비활성화할 수 없습니다.',
  84099224: '장치가 AMS D를 감지하지 못했습니다. AMS 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  84099229: 'AMS D의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  84099235: 'AMS(또는 AMS lite) D 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92291222: '장치가 AMS-HT A를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92291228: 'AMS-HT A의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92291234: 'AMS-HT A 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92356758: '장치가 AMS-HT B를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92356764: 'AMS-HT B의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92356770: 'AMS-HT B 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92422294: '장치가 AMS-HT C를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92422300: 'AMS-HT C의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92422306: 'AMS-HT C 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92487830: '장치가 AMS-HT D를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92487836: 'AMS-HT D의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92487842: 'AMS-HT D 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92553366: '장치가 AMS-HT F를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92553372: 'AMS-HT E의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92553378: 'AMS-HT E 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92618902: '장치가 AMS-HT E를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92618908: 'AMS-HT F의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92618914: 'AMS-HT F 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92684438: '장치가 AMS-HT G를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92684444: 'AMS-HT G의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업데이트하십시오.',
  92684450: 'AMS-HT G 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  92749974: '장치가 AMS-HT H를 감지하지 못했습니다. AMS-HT 케이블을 다시 연결하거나 프린터를 재시작하십시오.',
  92749980: 'AMS-HT H의 펌웨어가 프린터와 일치하지 않아서 장치가 계속 작동할 수 없습니다. \'펌웨어\' 페이지에서 업그레이드하십시오.',
  92749986: 'AMS-HT H 통신에 문제가 있습니다. 모듈 케이블을 다시 연결하거나 프린터를 다시 시작하세요.',
  100565075: '왼쪽 노즐이 슬라이싱 파일과 일치하지 않습니다. 다시 슬라이싱한 후 출력을 시작하거나 올바른 노즐을 교체한 후 출력을 계속하십시오. 주의: 핫엔드 온도가 높습니다.',
  100565097: '왼쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 핫엔드 유형을 수동으로 설정하세요.',
  100565098: '왼쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 다음 출력 전에 프린터 화면에서 핫엔드 유형을 설정하십시오.',
  100565120: '왼쪽 핫엔드가 설치되지 않았습니다.',
  100565121: '왼쪽 핫엔드가 설치되지 않았습니다.',
  100630611: '오른쪽 노즐이 슬라이싱 파일과 일치하지 않습니다. 다시 슬라이싱한 후 출력을 시작하거나 오른쪽 노즐을 교체한 후 출력을 계속하십시오. 주의: 핫엔드 온도가 높습니다.',
  100630633: '오른쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 핫엔드 유형을 수동으로 설정하세요.',
  100630634: '오른쪽 핫엔드를 인식할 수 없습니다. 비공식 핫엔드이거나 핫엔드 마크가 더러울 수 있습니다. 다음 출력 전에 프린터 화면에서 핫엔드 유형을 설정하십시오.',
  100630656: '오른쪽 핫엔드가 설치되지 않았습니다.',
  100630657: '오른쪽 핫엔드가 설치되지 않았습니다.',
  117456897: 'AMS는 출력할 수 없도록 설정되었지만 여전히 필라멘트가 로드되어 있습니다. AMS 필라멘트를 언로드하고 스풀 홀더 필라멘트로 전환하여 출력하십시오.',
  117456933: '필라멘트 정보를 읽지 못했습니다.',
  117473281: '필라멘트 절단 실패. 커터를 확인하십시오.',
  117473282: '커터가 걸렸습니다. 커터 손잡이가 밖으로 나와 있는지 확인하세요.',
  117473283: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117473284: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117473285: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117473286: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117473287: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117473290: 'PTFE 튜브 분리 감지됨. AMS A에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117473296: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117473297: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117473298: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117473299: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117473302: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117473303: 'AMS A 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  117473313: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117473315: 'AMS 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117489769: 'AMS A 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  117489770: 'AMS A RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117489771: 'AMS A 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117489772: 'AMS A가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117489773: 'AMS A 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117489774: 'AMS A 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117522433: '필라멘트가 비활성화된 후에도 여전히 AMS에서 로드됩니다. 필라멘트를 툴 헤드에서 제거 후 새로운 필라멘트를 스풀 홀더에 설치 후 인쇄를 다시 시작하십시오.',
  117522469: '필라멘트 정보를 읽지 못했습니다.',
  117538817: '필라멘트 절단 실패. 커터를 확인하십시오.',
  117538818: '커터가 걸렸습니다. 커터 손잡이가 밖으로 나와 있는지 확인하세요.',
  117538819: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117538820: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117538821: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117538822: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117538823: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117538826: 'PTFE 튜브 분리 감지됨. AMS B에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117538832: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117538833: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117538834: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117538835: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117538838: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117538839: 'AMS B 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  117538849: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117538851: 'AMS B 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117555305: 'AMS B 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  117555306: 'AMS B RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117555307: 'AMS B 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117555308: 'AMS B가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117555309: 'AMS B 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117555310: 'AMS B 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117587969: '필라멘트가 비활성화된 후에도 여전히 AMS에서 로드됩니다. 필라멘트를 툴 헤드에서 제거 후 새로운 필라멘트를 스풀 홀더에 설치 후 인쇄를 다시 시작하십시오.',
  117588005: '필라멘트 정보를 읽지 못했습니다.',
  117604353: '필라멘트 절단 실패. 커터를 확인하십시오.',
  117604354: '커터가 걸렸습니다. 커터 손잡이가 밖으로 나와 있는지 확인하세요.',
  117604355: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117604356: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117604357: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117604358: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117604359: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117604362: 'PTFE 튜브 분리 감지됨. AMS C에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117604368: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117604369: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117604370: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117604371: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117604374: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117604375: 'AMS C 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  117604385: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117604387: 'AMS C 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117620841: 'AMS C 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  117620842: 'AMS C RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117620843: 'AMS C 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117620844: 'AMS C가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117620845: 'AMS C 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117620846: 'AMS C 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117653505: '필라멘트가 비활성화된 후에도 여전히 AMS에서 로드됩니다. 필라멘트를 툴 헤드에서 제거 후 새로운 필라멘트를 스풀 홀더에 설치 후 인쇄를 다시 시작하십시오.',
  117653541: '필라멘트 정보를 읽지 못했습니다.',
  117669889: '필라멘트 절단 실패. 커터를 확인하십시오.',
  117669890: '커터가 걸렸습니다. 커터 손잡이가 밖으로 나와 있는지 확인하세요.',
  117669891: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117669892: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117669893: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117669894: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117669895: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117669898: 'PTFE 튜브 분리 감지됨. AMS D에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117669904: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117669905: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117669906: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117669907: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117669910: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117669911: 'AMS D 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  117669921: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117669923: 'AMS D 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117686377: 'AMS D 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  117686378: 'AMS D RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117686379: 'AMS D 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117686380: 'AMS D가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117686381: 'AMS D 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117686382: 'AMS D 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  117719077: '필라멘트 정보를 읽지 못했습니다.',
  117735427: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117735428: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117735429: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117735430: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117735431: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117735434: 'PTFE 튜브 분리 감지됨. AMS E에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117735440: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117735441: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117735442: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117735443: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117735446: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117735457: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117735459: 'AMS E 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117784613: '필라멘트 정보를 읽지 못했습니다.',
  117800963: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117800964: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117800965: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117800966: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117800967: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117800970: 'PTFE 튜브 분리 감지됨. AMS F에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117800976: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117800977: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117800978: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117800979: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117800982: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117800993: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117800995: 'AMS F 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117850149: '필라멘트 정보를 읽지 못했습니다.',
  117866499: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117866500: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117866501: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117866502: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117866503: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117866506: 'PTFE 튜브 분리 감지됨. AMS G에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117866512: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117866513: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117866514: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117866515: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117866518: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117866529: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117866531: 'AMS G 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  117915685: '필라멘트 정보를 읽지 못했습니다.',
  117932035: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  117932036: 'AMS가 필라멘트를 다시 당기지 못했습니다. 이는 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  117932037: 'AMS가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  117932038: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하세요.',
  117932039: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  117932042: 'PTFE 튜브 분리 감지됨. AMS H에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  117932048: 'AMS 보조 모터에 과부하가 걸렸습니다. 스풀이나 필라멘트가 끼여 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해주세요.',
  117932049: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  117932050: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  117932051: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  117932054: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  117932065: 'AMS 설정 실패. 도우미를 참조하십시오.',
  117932067: 'AMS H 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  134119425: '왼쪽 압출기의 필라멘트를 절단하지 못했습니다. 커터를 확인해 주세요.',
  134119426: '왼쪽 압출기의 커터가 걸렸습니다. 커터 손잡이를 당겨 빼주세요.',
  134119427: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  134119428: '왼쪽 압출기에서 필라멘트를 빼내지 못했습니다. 필라멘트가 압출기 내부에 끼어 있는지 확인하세요.',
  134119429: 'AMS 외부 필라멘트 공급 실패. 필라멘트 끝을 납작하게 자르고 스풀이 끼어 있는지 확인하세요.',
  134119430: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  134119431: '왼쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  134119440: '왼쪽 외부 필라멘트 스풀이나 필라멘트가 끼어 있는지 확인하세요.',
  134119441: '왼쪽 압출기에 연결된 외부 필라멘트가 다 떨어졌습니다. 새 필라멘트를 로드하십시오.',
  134119442: '매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  134119443: '왼쪽 압출기의 오래된 필라멘트 제거 시간 초과: 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  134119456: '압출기 변경에 실패했습니다. 도우미를 참조하세요.',
  134119457: 'AMS 설정 실패. 도우미를 참조하십시오.',
  134119460: '압출기 위치 보정에 실패했습니다. 도우미를 참조하세요.',
  134119461: '콜드 풀 시간이 초과되었습니다. 즉시 압출기를 작동하거나 압출기 내부의 필라멘트가 끊어졌는지 확인한 후 도우미를 클릭하여 자세한 내용을 확인하세요.',
  134119472: '슬라이서에서 지정된 필라멘트가 소진되었습니다. 출력이 일시 중지되었습니다. 기계로 이동하여 재료를 교체한 후 인쇄를 재개해 주세요.',
  134135811: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  134135814: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  134135816: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  134135817: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  134135818: '왼쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  134135824: '필라멘트(30cm 이상)를 멈출 때까지 삽입하세요. 세척하는 동안 약간의 연기가 날 수 있습니다. 삽입 후 앞문과 상단 덮개를 닫으세요.',
  134135825: '압출기에서 필라멘트를 손으로 천천히 당겨 빼내세요. 그런 다음 \'계속\'을 클릭하십시오.',
  134135826: '검정색 PTFE 튜브 커플러를 누르고 PTFE 튜브를 분리합니다. 작업을 완료한 후 \'계속\'을 클릭하세요.',
  134168577: '필라멘트가 비활성화된 후에도 여전히 AMS에서 로드됩니다. 필라멘트를 툴 헤드에서 제거 후 새로운 필라멘트를 스풀 홀더에 설치 후 인쇄를 다시 시작하십시오.',
  134184961: '오른쪽 압출기의 필라멘트를 절단하지 못했습니다. 커터를 확인해 주세요.',
  134184962: '오른쪽 압출기의 커터가 걸렸습니다. 커터 손잡이를 당겨 빼주세요.',
  134184963: '스풀 홀더에서 필라멘트를 빼내십시오. 이 메시지가 지속되면 압출기에 필라멘트가 끊어졌는지 확인하십시오. (AMS를 사용하려는 경우 PTFE 튜브를 연결하십시오.)',
  134184964: '오른쪽 압출기에서 필라멘트를 빼내지 못했습니다. 필라멘트가 압출기 내부에 끼어 있는지 확인하세요.',
  134184965: 'AMS 외부 필라멘트 공급 실패. 필라멘트 끝을 납작하게 자르고 스풀이 끼어 있는지 확인하세요.',
  134184966: '더 이상 밀 수 없을 때까지 PTFE 튜브에 필라멘트를 공급하십시오.',
  134184967: '노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  134184976: '오른쪽 외부 필라멘트 스풀이나 필라멘트가 끼어 있는지 확인하세요.',
  134184977: '오른쪽 압출기에 연결된 외부 필라멘트가 다 떨어졌습니다. 새 필라멘트를 로드하십시오.',
  134184978: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  134184979: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  134184992: '압출기 변경에 실패했습니다. 도우미를 참조하세요.',
  134184993: 'AMS 설정 실패. 도우미를 참조하십시오.',
  134184996: '압출기 위치 보정에 실패했습니다. 도우미를 참조하세요.',
  134184997: '콜드 풀링 시간이 초과되었습니다. Extruder 내부의 필라멘트 끊어짐 여부를 즉시 작동 또는 확인하시고 자세한 사항은 Assistant를 클릭하여 확인하시기 바랍니다.',
  134185008: '슬라이서에서 지정된 필라멘트가 소진되었습니다. 출력이 일시 중지되었습니다. 기계로 이동하여 재료를 교체한 후 인쇄를 재개해 주세요.',
  134201347: '스풀 홀더에서 필라멘트를 빼내십시오. 이 메시지가 지속되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하십시오. (AMS를 사용하려는 경우 PTFE 튜브를 연결하십시오.)',
  134201350: '더 이상 밀 수 없을 때까지 PTFE 튜브에 필라멘트를 공급하십시오.',
  134201352: '스풀 홀더에서 필라멘트를 빼내십시오. 이 메시지가 지속되면 압출기에 필라멘트가 끊어졌는지 확인하십시오. (AMS를 사용하려는 경우 PTFE 튜브를 연결하십시오.)',
  134201353: '더 이상 밀 수 없을 때까지 PTFE 튜브에 필라멘트를 공급하십시오.',
  134201354: '노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  134201360: '필라멘트(30cm 이상)를 멈출 때까지 삽입하세요. 세척하는 동안 약간의 연기가 날 수 있습니다. 삽입 후 앞문과 상단 덮개를 닫으세요.',
  134201361: '구동 휠 브래킷을 잡고 압출기에서 필라멘트를 천천히 당긴 다음 \'계속\'을 누릅니다.',
  134201362: '검정색 PTFE 튜브 커플러를 누르고 PTFE 튜브를 분리합니다. 작업을 완료한 후 \'계속\'을 클릭하세요.',
  201343008: '전망 카메라 설정에 실패했습니다. 모든 물체를 치우고 매트를 제거하세요. 마커가 가려져 있지 않은지 확인하세요. 한편, 전망 카메라와 툴헤드 카메라를 모두 청소하고 시야를 가리는 이물질을 제거하세요.',
  201343009: '전망 카메라 설정 실패. 프린터를 재부팅하십시오.',
  201343010: '전망 카메라 설정에 실패했습니다.  레이저 모듈이 제대로 작동하는지 확인하세요.',
  201343012: '전망 카메라가 오프셋으로 설치되어 있습니다. 다시 설치하려면 도우미를 참조하세요.',
  201343013: '전망 카메라가 더럽습니다. 청소하고 프로세스를 다시 시작하십시오.',
  201343014: '라이브 뷰 카메라를 초기화하지 못했습니다. 프린터를 재부팅하십시오.',
  201343015: '라이브 뷰 카메라 보정에 실패했습니다. 자세한 내용은 도우미에게 문의하고 처리 후 카메라를 다시 보정하세요.',
  201343017: '재료가 감지되지 않았습니다. 배치를 확인한 후 계속하세요.',
  201343018: '시각적 마커가 감지되지 않았습니다. 올바른 위치에 용지를 다시 붙여주세요.',
  201343020: '장치 데이터 링크 오류입니다. 프린터를 재부팅하세요',
  201343021: '툴헤드 카메라가 제대로 작동하지 않으니 기기를 재부팅하세요.',
  201343037: '비전 인코더 플레이트가 감지되지 않았습니다. 히트베드에 올바르게 배치되었는지 확인하세요.',
  201343038: '고정밀 노즐 오프셋 교정이 실패했습니다. 아마도 패턴이 손상되었거나 선택된 필라멘트 두 개의 색상이 비슷하기 때문일 수 있습니다. 인쇄된 패턴을 치우고 다시 교정하기 전에 색상 대비가 더 높은 필라멘트로 교체하십시오.',
  201343041: '툴헤드 카메라 보정에 실패했습니다. 열판의 보정 마커 또는 원점 복귀 영역의 높이 보정 마커가 깨끗하고 손상되지 않았는지 확인한 후 보정 프로세스를 다시 실행하세요.',
  201359361: '첫 레이어 결함이 감지되었습니다. 결함이 허용 가능한 수준이면 재개”를 선택하여 출력 작업을 재개하십시오.',
  201359362: '',
  201359365: '제거된 필라멘트가 폐기물 슈트에 쌓여 툴헤드 충돌을 일으킬 수 있습니다.',
  201359369: '빌드 플레이트 로컬라이제이션 마커를 찾을 수 없습니다.',
  201359371: '히트베드 마커가 감지되지 않았습니다. 모든 물체를 치우고 매트를 제거하세요. 마커가 가려져 있지 않은지 확인하세요.',
  201359381: '플랫폼에서 물체가 감지되었습니다. 적시에 청소하십시오.',
  201359382: '이물질 감지 기능이 작동하지 않습니다. 작업을 계속하거나 도우미에서 해결 방법을 확인할 수 있습니다.',
  201359383: '플랫폼에서 이물질이 감지되었으니 제때 청소해 주세요.',
  201359384: '이물질 감지 기능이 작동하지 않습니다. 작업을 계속 진행하거나 문제 해결을 위한 도우미를 볼 수 있습니다.',
  201359411: '신속 이탈 레버가 잠기지 않았습니다. 아래로 눌러 고정하세요.',
  201359412: '라이브뷰 카메라 초기화에 실패했습니다. 이 출력은 계속할 수 있지만 일부 AI 기능이 비활성화됩니다. 재시작 후 이 문제가 다시 발생하면 고객 지원팀에 문의하세요.',
  201359423: 'AI가 노즐 뭉침을 감지했습니다. 노즐 상태를 확인하세요. 해결 방법은 도우미를 참조하세요.',
  201359424: 'AI가 에어 프린팅 결함을 감지했습니다. 핫엔드 압출 상태를 확인하세요. 해결 방법은 도우미를 참조하세요.',
  201359426: 'AI 출력 모니터가 스파게티 결함을 감지했습니다. 출력물을 확인하고 필요한 조치를 취하십시오.',
  201359427: 'AI가 노즐 뭉침을 감지했습니다. 노즐 상태를 확인하세요. 해결 방법은 도우미를 참조하세요.',
  201375747: '첫 번째 레이어에서 가능한 결함이 감지되었습니다.',
  201375748: '스파게티 실패 가능성이 감지되었습니다.',
  201375750: '제거 필라멘트가 폐기물 슈트에 쌓였을 수 있습니다.',
  268484609: '베드 온도가 높으면 노즐의 필라멘트 막힘이 발생할 수 있습니다.챔버 도어를 열 수 있습니다.',
  268484610: 'CF 재료 필라멘트를 스테인리스 스틸로 출력하면 노즐이 손상될 수 있습니다.',
  268484611: '기존 모드에서 타임랩스를 활성화하면 결함이 발생할 수 있으므로 필요에 따라 이 기능을 활성화하세요.',
  268517377: '슬라이싱 프리셋에서 나선형 꽃병 모드가 활성화되어 있으므로 타임랩스는 지원되지 않습니다.',
  268517378: '출력 순서가 “개체별”로 설정되어 있기 때문에 타임랩스는 지원되지 않습니다.',
  268533763: '슬라이싱 파일에서 타임랩스 모드가 기존으로 설정되어 있습니다. 이로 인해 표면 결함이 발생할 수 있습니다. 활성화하시겠습니까?',
  268533764: '프라임 타워가 활성화되지 않고 타임랩스 모드가 슬라이싱 파일에서 부드럽게로 설정되어 있습니다. 이로 인해 표면 결함이 발생할 수 있습니다. 활성화하시겠습니까?',
  302006273: 'AMS가 비활성화 되었을 때 필라멘트가 여전히 AMS에서 로드된 것으로 감지되었습니다. 필라멘트를 AMS로 반환하고 트레이 홀더에서 새 재료를 로드한 후 인쇄를 다시 시작하십시오.',
  302022657: '필라멘트를 자르지 못했습니다. 필라멘트 커터를 확인하세요. 문제를 해결한 후 재시도 버튼을 선택해 주세요.',
  302022658: '커터가 멈췄습니다. 커터 핸들을 빼내고 재시도 버튼을 선택해 주세요.',
  302022659: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막혔는지 압출기 내부의 필라멘트가 파손되었는지 확인하십시오.',
  302022660: '툴헤드에서 필라멘트를 빼내지 못했습니다. 필라멘트가 끼어 있지 않은지 확인하십시오.',
  302022661: '필라멘트가 삽입되지 않았습니다. 필라멘트를 삽입하십시오.',
  302022662: '압출기에 필라멘트를 공급할 수 없습니다. 이는 필라멘트가 엉키거나 스풀이 끼었기 때문일 수 있습니다. 그렇지 않은 경우 AMS PTFE 튜브가 연결되어 있는지 확인하십시오.',
  302022663: '필라멘트 압출에 실패했습니다.이는 익스트루더가 막혔거나 필라멘트가 걸려서 발생할 수 있습니다. 해결 방법은 도우미에 문의하십시오.',
  302022672: '필라멘트나 스풀이 끼었을 수 있습니다.',
  302022673: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  302022674: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  302022675: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 끼었거나 압출기가 막혔는지 확인하십시오.',
  302022676: '툴헤드의 필라멘트 위치를 찾을 수 없습니다. 해결책은 도우미를 참조하세요.',
  302022677: '툴 헤드에서 필라멘트를 빼내지 못했습니다.필라멘트가 끼었는지, 익스트루더 또는 PTFE 튜브 내부의 필라멘트가 끊어졌는지 확인하십시오.',
  302022678: '압출기가 정상적으로 압출되지 않습니다. 문제 해결 방법은 도우미를 참조하세요. 이 레이어에 결함이 있을 수 있지만 결함이 허용 가능한 수준이면 다시 시작할 수 있습니다.',
  302071809: 'AMS가 비활성화 되었을 때 필라멘트가 여전히 AMS에서 로드된 것으로 감지되었습니다. 필라멘트를 AMS로 반환하고 트레이 홀더에서 새 재료를 로드한 후 인쇄를 다시 시작하십시오.',
  302088193: '필라멘트 절단 실패. 커터를 확인하십시오.',
  302088194: '커터가 멈췄습니다. 커터 핸들을 빼내고 재시도 버튼을 선택해 주세요.',
  302088195: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막혔는지 압출기 내부의 필라멘트가 파손되었는지 확인하십시오.',
  302088196: '툴헤드에서 필라멘트를 빼내지 못했습니다. 필라멘트가 끼어 있지 않은지 확인하십시오.',
  302088197: '필라멘트 공급 실패. 필라멘트를 로드한 다음 “재개”를 선택하십시오.',
  302088198: '필라멘트를 툴 헤드에 공급하지 못했습니다. 필라멘트가 끼어 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해 주세요.',
  302088199: '필라멘트 압출 실패. 압출기가 막혔거나 필라멘트가 끼었을 수 있습니다. HMS를 참조하십시오.',
  302088208: '스풀이나 필라멘트가 끼어 있는지 확인하십시오.',
  302088209: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  302088210: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  302088211: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 끼었거나 압출기가 막혔는지 확인하십시오.',
  302088212: '툴 헤드의 필라멘트 위치를 확인하지 못했습니다. HMS를 참조하십시오. 문제 해결 후 “재시도” 버튼을 클릭하십시오.',
  302088213: '툴헤드에서 필라멘트를 빼내지 못했습니다. 압출기 내부에서 필라멘트가 끼어 있거나 필라멘트가 파손되었는지 확인하십시오.',
  302088214: '압출기가 정상적으로 압출되지 않는 경우 HMS를 참조하십시오. 문제 해결 후 결함이 허용되면 출력을 다시 시작하십시오.',
  302137345: 'AMS가 비활성화 되었을 때 필라멘트가 여전히 AMS에서 로드된 것으로 감지되었습니다. 필라멘트를 AMS로 반환하고 트레이 홀더에서 새 재료를 로드한 후 인쇄를 다시 시작하십시오.',
  302153729: '필라멘트 절단 실패. 커터를 확인하십시오.',
  302153730: '커터가 멈췄습니다. 커터 핸들을 빼내고 재시도 버튼을 선택해 주세요.',
  302153731: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막혔는지 압출기 내부의 필라멘트가 파손되었는지 확인하십시오.',
  302153732: '툴헤드에서 필라멘트를 빼내지 못했습니다. 필라멘트가 끼어 있지 않은지 확인하십시오.',
  302153733: '필라멘트가 삽입되지 않았습니다. 필라멘트를 삽입하십시오.',
  302153734: '필라멘트를 툴 헤드에 공급하지 못했습니다. 필라멘트가 끼어 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해 주세요.',
  302153735: '필라멘트 압출 실패. 압출기가 막혔거나 필라멘트가 끼었을 수 있습니다. HMS를 참조하십시오.',
  302153744: '스풀이나 필라멘트가 끼어 있는지 확인하십시오.',
  302153745: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  302153746: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  302153747: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 끼었거나 압출기가 막혔는지 확인하십시오.',
  302153748: '툴 헤드의 필라멘트 위치를 확인하지 못했습니다. HMS를 참조하십시오. 문제 해결 후 “재시도” 버튼을 클릭하십시오.',
  302153749: '툴 헤드에서 필라멘트를 빼내는 데 실패했습니다.익스트루더 내부에 필라멘트가 끼었거나 끊어졌는지 확인해 주세요. 문제 해결 후 “재시도” 버튼을 클릭하십시오.',
  302153750: '압출기가 정상적으로 압출되지 않는 경우 HMS를 참조하십시오. 문제 해결 후 결함이 허용되면 출력을 다시 시작하십시오.',
  302202881: 'AMS가 비활성화 되었을 때 필라멘트가 여전히 AMS에서 로드된 것으로 감지되었습니다. 필라멘트를 AMS로 반환하고 트레이 홀더에서 새 재료를 로드한 후 인쇄를 다시 시작하십시오.',
  302219265: '필라멘트 절단 실패. 커터를 확인하십시오.',
  302219266: '커터가 멈췄습니다. 커터 핸들을 빼내고 재시도 버튼을 선택해 주세요.',
  302219267: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막혔는지 압출기 내부의 필라멘트가 파손되었는지 확인하십시오.',
  302219268: '툴헤드에서 필라멘트를 빼내지 못했습니다. 필라멘트가 끼어 있지 않은지 확인하십시오.',
  302219269: '필라멘트가 삽입되지 않았습니다. 필라멘트를 삽입하십시오.',
  302219270: '필라멘트를 툴 헤드에 공급하지 못했습니다. 필라멘트가 끼어 있는지 확인하십시오. 문제 해결 후 재시도 버튼을 선택해 주세요.',
  302219271: '필라멘트 압출 실패. 압출기가 막혔거나 필라멘트가 끼었을 수 있습니다. HMS를 참조하십시오.',
  302219280: '스풀이나 필라멘트가 끼어 있는지 확인하십시오.',
  302219281: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  302219282: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  302219283: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 끼었거나 압출기가 막혔는지 확인하십시오.',
  302219284: '툴헤드의 필라멘트 위치를 확인하지 못했습니다. HMS를 참조하십시오.',
  302219285: '툴 헤드에서 필라멘트를 빼내는 데 실패했습니다.익스트루더 내부에 필라멘트가 끼었거나 끊어졌는지 확인해 주세요. 문제 해결 후 “재시도” 버튼을 클릭하십시오.',
  302219286: '압출기가 정상적으로 압출되지 않는 경우 HMS를 참조하십시오. 문제 해결 후 결함이 허용되면 출력을 다시 시작하십시오.',
  318717953: 'AMS가 비활성화 되었을 때 필라멘트가 여전히 AMS에서 로드된 것으로 감지되었습니다. 필라멘트를 AMS로 반환하고 트레이 홀더에서 새 재료를 로드한 후 인쇄를 다시 시작하십시오.',
  318734337: '필라멘트 절단 실패. 커터를 확인하십시오.',
  318734338: '커터가 멈췄습니다. 커터 핸들을 빼내고 재시도 버튼을 선택해 주세요.',
  318734339: '스풀 홀더에서 필라멘트를 빼내십시오. 이 메시지가 지속되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하십시오. (AMS를 사용하려는 경우 PTFE 튜브를 연결하십시오.)',
  318734340: '툴헤드에서 필라멘트를 빼내지 못했습니다. 필라멘트가 끼어 있지 않은지 확인하십시오.',
  318734341: '필라멘트가 삽입되지 않았습니다. 필라멘트를 삽입하십시오.',
  318734342: '더 이상 밀 수 없을 때까지 PTFE 튜브에 필라멘트를 공급하십시오.',
  318734343: '노즐을 확인하십시오. 필라멘트가 압출된 경우 \'완료\'를 선택하고, 그렇지 않으면 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택해 주세요.',
  318734352: '스풀이나 필라멘트가 끼여 있는지 확인하십시오.',
  318734353: 'AMS 필라멘트가 소진되었습니다. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  318734354: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  318734355: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 끼었거나 압출기가 막혔는지 확인하십시오.',
  318750723: '스풀 홀더에서 필라멘트를 빼내십시오. 이 메시지가 지속되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하십시오. (AMS를 사용하려는 경우 PTFE 튜브를 연결하십시오.)',
  318750726: '더 이상 밀 수 없을 때까지 PTFE 튜브에 필라멘트를 공급하십시오.',
  402669605: '필라멘트 정보를 읽지 못했습니다.',
  402685955: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  402685956: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  402685957: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  402685958: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  402685959: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  402685962: 'PTFE 튜브 분리 감지됨. AMS-HT A에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  402685968: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  402685969: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  402685970: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  402685971: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  402685974: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  402685975: 'AMS-HT A 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  402685985: 'AMS 설정 실패. 도우미를 참조하십시오.',
  402685987: 'AMS-HT A 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  402702441: 'AMS-HT A 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  402702442: 'AMS-HT A RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402702443: 'AMS-HT A 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402702444: 'AMS-HT A가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402702445: 'AMS-HT A 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402702446: 'AMS-HT A 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402735141: '필라멘트 정보를 읽지 못했습니다.',
  402751491: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  402751492: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  402751493: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  402751494: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  402751495: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  402751498: 'PTFE 튜브 분리 감지됨. AMS-HT B에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  402751504: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  402751505: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  402751506: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  402751507: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  402751510: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  402751511: 'AMS-HT B 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  402751521: 'AMS 설정 실패. 도우미를 참조하십시오.',
  402751523: 'AMS-HT B 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  402767977: 'AMS-HT B 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  402767978: 'AMS-HT B RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402767979: 'AMS-HT B 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402767980: 'AMS-HT B가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402767981: 'AMS-HT B 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402767982: 'AMS-HT B 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402800677: '필라멘트 정보를 읽지 못했습니다.',
  402817027: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  402817028: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  402817029: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  402817030: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  402817031: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  402817034: 'PTFE 튜브 분리 감지됨. AMS-HT C에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  402817040: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  402817041: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  402817042: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  402817043: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  402817046: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  402817047: 'AMS-HT C 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  402817057: 'AMS 설정 실패. 도우미를 참조하십시오.',
  402817059: 'AMS-HT C 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  402833513: 'AMS-HT C 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  402833514: 'AMS-HT C RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402833515: 'AMS-HT C 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402833516: 'AMS-HT C가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402833517: 'AMS-HT C 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402833518: 'AMS-HT C 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402866213: '필라멘트 정보를 읽지 못했습니다.',
  402882563: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  402882564: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  402882565: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  402882566: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  402882567: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  402882570: 'PTFE 튜브 분리 감지됨. AMS-HT D에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  402882576: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  402882577: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  402882578: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  402882579: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  402882582: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  402882583: 'AMS-HT D 건조 중. 재료를 로드/언로드하기 전에 건조 과정을 중지하십시오.',
  402882593: 'AMS 설정 실패. 도우미를 참조하십시오.',
  402882595: 'AMS-HT D 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  402899049: 'AMS-HT D 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  402899050: 'AMS-HT D RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402899051: 'AMS-HT D 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402899052: 'AMS-HT D가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402899053: 'AMS-HT D 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402899054: 'AMS-HT D 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402931749: '필라멘트 정보를 읽지 못했습니다.',
  402948099: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  402948100: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  402948101: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  402948102: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  402948103: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  402948106: 'PTFE 튜브 분리 감지됨. AMS-HT E에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  402948112: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  402948113: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  402948114: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  402948115: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  402948118: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  402948129: 'AMS 설정 실패. 도우미를 참조하십시오.',
  402948131: 'AMS-HT E 냉각에 문제가 발생했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  402964585: 'AMS-HT E 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  402964586: 'AMS-HT E RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402964587: 'AMS-HT E 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402964588: 'AMS-HT E가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402964589: 'AMS-HT E 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402964590: 'AMS-HT E 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  402997285: '필라멘트 정보를 읽지 못했습니다.',
  403013635: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  403013636: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  403013637: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  403013638: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  403013639: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  403013642: 'PTFE 튜브 분리 감지됨. AMS-HT F에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  403013648: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  403013649: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  403013650: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  403013651: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  403013654: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  403013665: 'AMS 설정 실패. 도우미를 참조하십시오.',
  403013667: 'AMS-HT F 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  403030121: 'AMS-HT F 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  403030122: 'AMS-HT F RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403030123: 'AMS-HT F 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403030124: 'AMS-HT F가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403030125: 'AMS-HT F 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403030126: 'AMS-HT F 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403062821: '필라멘트 정보를 읽지 못했습니다.',
  403079171: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  403079172: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  403079173: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  403079174: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  403079175: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  403079178: 'PTFE 튜브 분리 감지됨. AMS-HT G에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  403079184: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  403079185: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  403079186: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  403079187: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  403079190: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  403079201: 'AMS 설정 실패. 도우미를 참조하십시오.',
  403079203: 'AMS-HT G 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  403095657: 'AMS-HT G 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  403095658: 'AMS-HT G RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403095659: 'AMS-HT G 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403095660: 'AMS-HT G가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403095661: 'AMS-HT G 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403095662: 'AMS-HT G 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403128357: '필라멘트 정보를 읽지 못했습니다.',
  403144707: '압출기에서 필라멘트를 빼내지 못했습니다. 압출기가 막히거나 압출기 내부에서 필라멘트가 끊어졌기 때문일 수 있습니다.',
  403144708: 'AMS-HT가 필라멘트를 뒤로 당기지 못했습니다. 스풀이 걸렸거나 필라멘트 끝이 경로에 걸렸기 때문일 수 있습니다.',
  403144709: 'AMS-HT가 필라멘트를 보내지 못했습니다. 필라멘트 끝을 납작하게 자른 후 다시 삽입할 수 있습니다. 이 메시지가 계속 표시되면 AMS의 PTFE 튜브에 마모된 흔적이 있는지 확인하세요.',
  403144710: '압출기에 필라멘트를 공급할 수 없습니다. 필라멘트가 얽히거나 스풀이 걸렸기 때문일 수 있습니다. 그렇지 않은 경우 AMS-HT PTFE 튜브가 연결되어 있는지 확인하세요.',
  403144711: '필라멘트 압출 실패. 압출기가 막혔는지 확인하십시오.',
  403144714: 'PTFE 튜브 분리 감지됨. AMS-HT H에서 압출기로 가는 PTFE 튜브가 제대로 연결되었는지 확인하십시오.',
  403144720: 'AMS-HT 보조 모터에 과부하가 걸렸습니다. 필라멘트가 엉키거나 스풀이 걸렸기 때문일 수 있습니다.',
  403144721: 'AMS-HT 필라멘트 소진. 같은 AMS 슬롯에 새 필라멘트를 삽입하세요.',
  403144722: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  403144723: '기존 필라멘트를 제거하는 동안 시간이 초과되었습니다. 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  403144726: '압출기가 정상적으로 압출되지 않습니다. 도우미를 참조하십시오. 문제 해결 후. 결함이 수용 가능한 경우 재개하십시오.',
  403144737: 'AMS 설정 실패. 도우미를 참조하십시오.',
  403144739: 'AMS-HT H 냉각에 실패했습니다. 주변 온도가 너무 높을 수 있습니다. 적절한 환경에서 기기를 작동해 주세요.',
  403161193: 'AMS-HT H 건조 중에 오류가 발생했습니다. 자세한 내용은 도우미를 참조하십시오.',
  403161194: 'AMS-HT H RFID를 읽는 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403161195: 'AMS-HT H 필라멘트 교체 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403161196: 'AMS-HT H가 피드 지원 모드입니다. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403161197: 'AMS-HT H 필라멘트 삽입 지원 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  403161198: 'AMS-HT H 모터 셀프 테스트 수행 중. 건조를 시작할 수 없습니다. 나중에 다시 시도하십시오.',
  419332097: '왼쪽 압출기의 필라멘트를 절단하지 못했습니다. 커터를 확인해 주세요.',
  419332098: '왼쪽 압출기의 커터가 걸렸습니다. 커터 손잡이를 당겨 빼주세요.',
  419332099: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419332100: '왼쪽 압출기에서 필라멘트를 빼내지 못했습니다. 필라멘트가 압출기 내부에 끼어 있는지 확인하세요.',
  419332101: 'AMS-HT 외부 필라멘트 공급 실패. 필라멘트 끝을 납작하게 자르고 스풀이 끼어 있는지 확인하세요.',
  419332102: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419332103: '왼쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  419332113: '왼쪽 압출기에 연결된 외부 필라멘트가 다 떨어졌습니다. 새 필라멘트를 로드하십시오.',
  419332114: '매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  419332115: '왼쪽 압출기의 오래된 필라멘트 제거 시간 초과: 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  419332128: '압출기 변경에 실패했습니다. 도우미를 참조하세요.',
  419332129: 'AMS 설정 실패. 도우미를 참조하십시오.',
  419332132: '압출기 위치 보정에 실패했습니다. 도우미를 참조하세요.',
  419348483: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419348486: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419348488: '왼쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419348489: '더 이상 밀 수 없을 때까지 왼쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419348490: '왼쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  419397633: '오른쪽 압출기의 필라멘트를 절단하지 못했습니다. 커터를 확인해 주세요.',
  419397634: '오른쪽 압출기의 커터가 걸렸습니다. 커터 손잡이를 당겨 빼주세요.',
  419397635: '오른쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419397636: '오른쪽 압출기에서 필라멘트를 빼내지 못했습니다. 필라멘트가 압출기 내부에 끼어 있는지 확인하세요.',
  419397637: 'AMS-HT 외부 필라멘트 공급 실패. 필라멘트 끝을 납작하게 자르고 스풀이 끼어 있는지 확인하세요.',
  419397638: '더 이상 밀 수 없을 때까지 오른쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419397639: '오른쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
  419397649: '오른쪽 압출기에 연결된 외부 필라멘트가 다 떨어졌습니다. 새 필라멘트를 로드하십시오.',
  419397650: 'AMS 매핑 테이블 가져오기 실패. 다시 시도하려면 “재개”을 선택하십시오.',
  419397651: '오른쪽 압출기의 오래된 필라멘트 제거 시간 초과: 필라멘트가 걸렸거나 압출기가 막혔는지 확인하십시오.',
  419397664: '압출기 변경에 실패했습니다. 도우미를 참조하세요.',
  419397665: 'AMS 설정 실패. 도우미를 참조하십시오.',
  419397668: '압출기 위치 보정에 실패했습니다. 도우미를 참조하세요.',
  419414019: '오른쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419414022: '더 이상 밀 수 없을 때까지 오른쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419414024: '오른쪽 압출기의 스풀 홀더에 있는 필라멘트를 빼내주세요. 이 메시지가 계속 표시되면 압출기 또는 PTFE 튜브에 필라멘트가 끊어졌는지 확인하세요. (AMS를 사용하려는 경우 PTFE 튜브를 연결하세요.)',
  419414025: '더 이상 밀 수 없을 때까지 오른쪽 압출기의 PTFE 튜브에 필라멘트를 공급하십시오.',
  419414026: '오른쪽 압출기의 노즐을 관찰하십시오. 필라멘트가 압출된 경우 \'계속\'을 선택하십시오. 그렇지 않은 경우 필라멘트를 약간 앞으로 밀고 \'재시도\'를 선택하십시오.',
};

export default BAMBU_ERRORS;
